module.exports = __webpack_public_path__ + "img/4-2.3c2a9a72.jpg";